import { createStructuredSelector } from 'reselect';
import {
  isSidebarVisibleSelector,
  isRecordingStartSelector,
  userDataSelector,
} from '../../selectors/global';
import { currentAppraisalYearSelector } from '@modules/appraisal/selectors/global';
import { getPropertyAsCodeDropdownsState } from '@modules/appraisal/selectors/property';

export default createStructuredSelector({
  currentAppraisalYear: currentAppraisalYearSelector,
  isRecordingStart: isRecordingStartSelector,
  isSidebarVisible: isSidebarVisibleSelector,
  userData: userDataSelector,
  asCodeDropdownsState: getPropertyAsCodeDropdownsState,
});
